module.exports = __webpack_public_path__ + "static/img/h-winicon.ca2d47fd.png";